// ============================================================================
// MarketMasterCabinetCard — понятный вход в «Кабинет мастера» из профиля.
// Показывается ТОЛЬКО когда в базе есть профиль мастера (mkt_masters.entity_id
// = текущий пользователь; роль определяет useMarketRole по серверным данным).
// Никаких «стань мастером» без API — только честный вход в существующий кабинет.
// ============================================================================

import { Briefcase, ChevronRight, MapPin, Wallet } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface MarketMasterCabinetCardProps {
  onOpenFeed: () => void;
  onOpenWallet: () => void;
  /** Зона обслуживания мастера (страна/регион/город/район, координаты, радиус). */
  onOpenArea: () => void;
}

export function MarketMasterCabinetCard({
  onOpenFeed,
  onOpenWallet,
  onOpenArea,
}: MarketMasterCabinetCardProps) {
  return (
    <section className="space-y-3 rounded-2xl border border-primary/25 bg-gradient-to-br from-primary/10 via-primary/5 to-background p-4">
      <div className="flex items-start gap-2">
        <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-primary/15 text-primary">
          <Briefcase className="h-4 w-4" />
        </div>
        <div className="min-w-0 flex-1">
          <h2 className="text-sm font-semibold">Кабинет мастера</h2>
          <p className="mt-0.5 text-[11px] leading-5 text-muted-foreground">
            Профиль мастера найден. Свободные заявки, взятые заявки и кошелёк — в вашем кабинете.
          </p>
        </div>
      </div>
      <div className="grid grid-cols-1 gap-2 sm:grid-cols-2">
        <Button type="button" className="h-10 rounded-xl" onClick={onOpenFeed}>
          <Briefcase className="mr-1.5 h-4 w-4" />
          Свободные заявки
          <ChevronRight className="ml-1 h-4 w-4" />
        </Button>
        <Button type="button" variant="outline" className="h-10 rounded-xl" onClick={onOpenWallet}>
          <Wallet className="mr-1.5 h-4 w-4" />
          Кошелёк
        </Button>
        <Button
          type="button"
          variant="outline"
          className="h-10 rounded-xl sm:col-span-2"
          onClick={onOpenArea}
        >
          <MapPin className="mr-1.5 h-4 w-4" />
          Зона обслуживания
        </Button>
      </div>
    </section>
  );
}
